<template>
  <SoTooltip location="top" :text="detail" :disabled="detail.length === 0">
    <SoChip
      :type="chipType"
      :text="health.verdict"
      size="small"
      data-testid="health-verdict-chip"
    />
  </SoTooltip>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import { SoChipType } from "@/types/components/SoChip"
  import {
    AccountHealth,
    HealthVerdict,
  } from "@/models/admin/testAccountHealth/testAccountHealth.types"

  const CHIP_TYPES: Record<HealthVerdict, SoChipType> = {
    OK: SoChipType.SUCCESS,
    DRIFTED: SoChipType.WARNING,
    FLAPPING: SoChipType.IMPORTANT,
    ERROR: SoChipType.ERROR,
  }

  export default defineComponent({
    components: { SoChip, SoTooltip },
    props: {
      health: { type: Object as PropType<AccountHealth>, required: true },
    },
    computed: {
      chipType(): SoChipType {
        return CHIP_TYPES[this.health.verdict]
      },
      detail(): string {
        return [
          ...this.health.errors,
          ...this.health.flappingFields.map((f) => `flapping: ${f}`),
          ...this.health.driftedFields.map((f) => `drifted: ${f}`),
        ].join(", ")
      },
    },
  })
</script>
